import axios from 'axios';
import { UserInfo } from '@microsoft/teamsfx';

import { ErrorCodes } from 'src/utils/enums';
import { ERROR_MESSAGES } from 'src/utils/constants';
import { AppError } from './AppError';

type ApiErrorConstructorParams = {
  message: string
  endpoint: string
  statusCode?: string | number | null
  user?: UserInfo | null
  originalError?: unknown
  context?: Record<string, unknown>
};

export class ApiError extends AppError {
  constructor({ message, endpoint, statusCode, user, originalError, context }: ApiErrorConstructorParams) {
    super({ name: 'ApiError', message, errorCode: ErrorCodes.API, user, originalError, context: { ...context, statusCode, endpoint } });
  }
}

export function handleApiError(error: unknown, endpoint: string): never {
  if (error instanceof AppError && error.isLogged) {
    throw error;
  }

  let statusCode: string | number | null | undefined;
  const baseErrorMessage = ERROR_MESSAGES.cannotCallApi(endpoint);
  let errorMessage = `${baseErrorMessage} - ${ERROR_MESSAGES.unknownError}`;

  if (axios.isAxiosError(error)) {
    statusCode = error.response?.status || error.code || 0;
    errorMessage = `${baseErrorMessage} - ${error.response?.data?.message || error.message || ERROR_MESSAGES.unknownError}`;
  }
  else if (error instanceof Error) {
    errorMessage = `${baseErrorMessage} - ${error.message}`;
  }

  const apiError = new ApiError({ message: errorMessage, endpoint, statusCode, originalError: error });

  apiError.logError();

  throw apiError;
}
